<template>
    <Map class="animated fadeIn" :gestureHandling="false" />
</template>

<script>
import Map from '@/components/Map';

export default {
    components: {
        Map
    }
};
</script>
